import { useEffect, useState } from "react";
import { apiGetSettings } from "../../graphQL/settings";
import { useSettingsDomain, settingsScope } from "../../graphQL/settings/scope";

// Scope comes from the active domain; the legacy authorId argument is ignored.
export const usePropertyCategories = () => {
  const domain = useSettingsDomain();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const input = {
          schemaType: "category",
          type: "property",
          ...settingsScope(domain),
        };
        const result = await apiGetSettings(input);
        const settings = Array.isArray(result?.settings) ? result.settings : [];
        const latest = settings.reduce((acc, cur) => {
          const accTs = Number(acc?.updatedAt ?? acc?.createdAt ?? 0);
          const curTs = Number(cur?.updatedAt ?? cur?.createdAt ?? 0);
          return curTs >= accTs ? cur : acc;
        }, settings[0] || null);
        const payload = latest?.data;
        const raw = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        if (cancelled) return;
        setCategories(
          raw.map((cat, i) => ({
            ...cat,
            id: cat?.id || cat?.value || `cat_${i}`,
            isActive:
              typeof cat?.isActive === "boolean"
                ? cat.isActive
                : (typeof cat?.style?.isActive === "boolean" ? cat.style.isActive : true),
          }))
        );
      } catch (e) {
        console.error("Failed to load property categories:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [domain]);

  return categories;
};

